<script>
import { Button, Field, Form, Toast } from "vant";
import { formatDateToDDMMYYYYHHMMSS } from "@/ultis/dateFormat";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Form.name]: Form,
    [Toast.name]: Toast,
  },
  data() {
    return {
      payment: {
        amount: "",
        account: "",
        currency: "USD",
      },
      doPayment: "",
      loading: false,
    };
  },
  methods: {
    formatDateToDDMMYYYYHHMMSS,
    onSubmit() {
      this.loading = true;
      console.log("[==> doPayment]", this.payment);
      this.$bridge
        .callHandler("doPayment", this.payment)
        .then(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    // set bar title
    this.$bridge.callHandler("setBarTitle", { title: "Payment Page", color: "#ffffff" });
  },
  async mounted() {
    this.$bridge.registerHandler("getStatus", async (data) => {
      // Call API xử lý
      const currentDate = new Date();
      const currentDateSTR = formatDateToDDMMYYYYHHMMSS(currentDate);

      console.log("Data: ", data);
      if (data) {
        this.transactionId = data.transactionId;

        // gọi api formatDateToDDMMYYYYHHMMSS

        // let account = "";
        // if (this.profile) {
        //   account = this.profile.appId;
        //   // account = this.profile.phone.replace(/\D/g, "");
        // }

        // if (this.consumerId == null) return;

        // // DataInput before encrypt and sign
        // let mes = `<data>    <merchantAccount>MINI_APP</merchantAccount>    <isdn>${this.formatSpacingPhoneNumber(
        //   this.phoneNumber
        // )}</isdn>    <packageCode>${this.item.subCode
        //   }</packageCode>    <serviceType>EXCHANGE_DATA_OSJA</serviceType>    <time>${currentDateSTR}</time>    <requestId>${this.consumerId
        //   }</requestId>    <account>${account}</account></data>`;

        // console.log("Mes: ", mes);
        // const params = this.stateAsObject(this.defaultParam);
        // const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
        // const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
        // params.signature = sign(mes, privateKeyPem);
        // params.encrypt = encrypt(mes, publicKeyPem);
        // await this.$store
        //   .dispatch("metfoneStore/buyPackage", params)
        //   .then(async (res) => {
        //     if (res) {
        //       let result = res.data;
        //       if (result && result.errorCode == 0) {
        //         this.resultSuccess = {
        //           subcribeId: this.transactionId
        //             ? this.transactionId
        //             : "0000000",
        //           subcribeDate: formatDateToEN_US(currentDate, this.isKHM()),
        //           paidFrom: this.isdn ? this.isdn : "012345678",
        //           price: this.getPrice,
        //           unit: this.item.unit,
        //           content: this.item.subFullDes ? this.item.subFullDes : "",
        //           title: this.item.serviceName,
        //         };
        //         this.$router.replace({
        //           path: "payment-success",
        //           query: this.resultSuccess,
        //         });
        //       } else {
        //         this.$router.replace({
        //           path: "payment-faild",
        //         });
        //       }
        //     }
        //   });
        // this.showLoading = false;
      } else {
        // Lỗi khi gọi app ABA thanh toán
        // Data null
      }
    });
  },
};
</script>
<template>
  <div>
    <h2 style="padding: 16px">Payment</h2>
    <van-form @submit="onSubmit">
      <van-field
        v-model="payment.amount"
        label="Amount"
        placeholder="0.00"
        type="number"
        :rules="[{ required: true, message: 'Amount is required' }]"
      />
      <van-field
        v-model="payment.account"
        label="Account"
        placeholder="012345"
        :rules="[{ required: true, message: 'Account is required' }]"
      />

      <div style="margin: 16px">
        <van-button
          :loading="loading"
          round
          block
          type="primary"
          native-type="submit"
        >
          Submit
        </van-button>
      </div>
    </van-form>
    <!-- <h2>{{ doPayment }}</h2> -->
  </div>
</template>
